// Generated by CoffeeScript 1.9.3
var chroma, color, contrastSearch, counter, debug, targetColor;

chroma = require('chroma-js');

debug = require('debug')('color-pairs-picker-binary-search-contrast');

counter = 0;

module.exports = contrastSearch = function(targetColor, compareColor, start, end, direction, contrast) {
  var b, color, curContrast, middle;
  if (compareColor == null) {
    compareColor = targetColor;
  }
  if (start == null) {
    start = 0;
  }
  if (end == null) {
    end = 1;
  }
  if (direction == null) {
    direction = "end";
  }
  if (contrast == null) {
    contrast = 5;
  }
  counter += 1;
  middle = (start + end) / 2;
  b = chroma(targetColor, 'lab');
  color = b.luminance(middle).lab();
  curContrast = chroma.contrast(chroma(compareColor).css(), b.css());
  if (counter > 15) {
    counter = 0;
    return color;
  }
  if ((contrast - 0.1) < curContrast && curContrast < (contrast + 0.1)) {
    counter = 0;
    return color;
  }
  if (curContrast > contrast) {
    if (direction === "end") {
      return contrastSearch(targetColor, compareColor, start, middle - 0.001, direction, contrast);
    } else {
      return contrastSearch(targetColor, compareColor, middle + 0.001, end, direction, contrast);
    }
  } else if (curContrast < contrast) {
    if (direction === "start") {
      return contrastSearch(targetColor, compareColor, start, middle - 0.001, direction, contrast);
    } else {
      return contrastSearch(targetColor, compareColor, middle + 0.001, end, direction, contrast);
    }
  }
};

color = 'rgb(8, 27, 44)';

targetColor = 'rgb(124, 171, 217)';

color = 'red';

targetColor = 'red';



/*****************
 ** WEBPACK FOOTER
 ** ../~/color-pairs-picker/dist/contrastSearch.js
 ** module id = 383
 ** module chunks = 0
 **/